/***
 *
 *   DATE
 *   Locale-aware date formatting for the list views.
 *
 *   dayjs formats in English until a locale is loaded AND selected, so
 *   `MMM D` rendered "Feb 3" on the French UI. Both locales are imported here
 *   and `formatDate` picks the active one at call time, which keeps it correct
 *   after a language switch without every caller re-rendering dayjs config.
 *
 **********/

import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import { getLocale } from 'app/translations';

// `ll` / `LL` are localised tokens — without this plugin they render literally.
dayjs.extend(localizedFormat);

export function formatDate(value, format = 'll') {
    if (!value) return null;

    const date = dayjs(value);
    if (!date.isValid()) return null;

    return date.locale(getLocale()).format(format);
}

/**
 * Short day + month, as the reference uses for ticket due dates. Month-first
 * in English, day-first in French — which is why this is not one format string.
 */
export function formatShortDate(value) {
    return formatDate(value, getLocale() === 'fr' ? 'D MMM' : 'MMM D');
}
